import { useContext } from "react";
import { AdminThemeContext } from "../context/AdminThemeContext";
import { Link, useNavigate } from "react-router-dom";

export default function Header({ toggleSidebar }) {
  const { setTheme } = useContext(AdminThemeContext);

  const toggleDark = () => {
    setTheme((prev) => ({ ...prev, dark: !prev.dark }));
  };

  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");

    navigate("/admin");
  };

  return (
    <div className="header shadow-sm p-3 d-flex align-items-center bg-white">
      <button className="btn btn-light me-3" onClick={toggleSidebar}>
        <i className="bi bi-list fs-4"></i>
      </button>

      <h5 className="mb-0">Admin Panel</h5>

      <div className="ms-auto d-flex align-items-center gap-3">
        {/* <Link
          to="/admin/settings"
          className="btn btn-outline-secondary btn-sm"
          onClick={toggleDark}
        >
          <i className="bi bi-gear"></i>
        </Link> */}

        <div className="dropdown">
          <button
            className="btn profile-btn d-flex align-items-center gap-2"
            data-bs-toggle="dropdown"
          >
            <img
              src="/avatar.png"
              className="rounded-circle"
              width="34"
              height="34"
              alt="profile"
            />
            <span className="fw-semibold d-none d-md-inline">Admin</span>
          </button>

          <ul className="dropdown-menu dropdown-menu-end profile-dropdown">
            <li className="dropdown-header">
              <strong>Admin</strong>
              <small className="text-muted d-block">Administrator</small>
            </li>

            <li>
              <hr className="dropdown-divider" />
            </li>

            <li>
              <Link className="dropdown-item" to="#">
                <i className="bi bi-person me-2"></i>My Profile
              </Link>
            </li>

            <li>
              <hr className="dropdown-divider" />
            </li>

            <li>
              <button className="dropdown-item text-danger" onClick={logout}>
                <i className="bi bi-box-arrow-right me-2"></i>Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
